import { createContext, useContext } from "react";

import { cn } from "@/lib/utils";

export function Skeleton({
  children,
  className,
  loading: loadingProp,
}: {
  children?: React.ReactNode;
  className?: string;
  loading?: boolean;
}) {
  const context = useContext(SkeletonContext);
  const loading = loadingProp ?? context?.loading;
  if (loading == null) {
    throw new Error(
      "Skeleton loading state is not set. This component must be a child of a SkeletonProvider if the loading prop is not set.",
    );
  }

  if (!loading) {
    return children;
  }

  return (
    <div className="relative">
      <div className="invisible pointer-events-none" aria-hidden="true">
        {children}
      </div>
      <div
        className={cn(
          "absolute inset-0 animate-pulse rounded-md bg-primary/10",
          className,
        )}
        aria-busy="true"
      />
    </div>
  );
}
const SkeletonContext = createContext<{ loading: boolean } | null>(null);

export function SkeletonProvider({
  children,
  loading,
}: {
  children: React.ReactNode;
  loading: boolean;
}) {
  return (
    <SkeletonContext.Provider value={{ loading }}>
      {children}
    </SkeletonContext.Provider>
  );
}
